module.exports = "<div class=\"photo-with-credit d-none d-md-block\">\n    <img class=\"photo-image\" [src]=\"imageSrc\">\n    <div *ngIf=\"bannerText\" class=\"banner-text-container\">\n        <p class=\"banner-text\">\n            {{ bannerText }}\n        </p>\n    </div>\n\n    <div class=\"photo-credit-container\">\n        <p class=\"photo-credit-text\"\n           [innerHTML] = \"photoCredits\">\n        </p>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/partials/photo-with-credit/photo-with-credit.html
// module id = ./src/app/partials/photo-with-credit/photo-with-credit.html
// module chunks = main